import { type Ref, computed } from 'vue'

export const useBackgroundColor = (background: Ref<Background | undefined>) => {
  if (!background) return ''

  return computed(() => [
    `bg-${background.value}`,
    {
      'text-burgundy': background.value === 'dustrose',
      'text-dustrose [&_*]:selection:!bg-pink [&_*]:selection:!text-burgundy':
        background.value === 'burgundy',
      '[&_a]:bg-burgundy [&_a]:hover:bg-dustrose [&_a]:text-dustrose [&_a]:hover:text-burgundy [&_a]:hover:border-burgundy':
        background.value === 'dustrose',
    },
  ])
}
